import AttachmentsTab from './AttachmentsTab';
import ContributorsTab from './ContributorsTab';
import DetailsTab from './DetailsTab';
import FieldsTab from './FieldsTab';

export default {
  AttachmentsTab,
  ContributorsTab,
  DetailsTab,
  FieldsTab
};
